<template>
	<div class="page" :class="theme" :style="customStyles">
		<div class="page-content">
			<slot name="content"></slot>
		</div>
		<div v-if="$slots.footer" class="page-footer" :class="{ show: showFooter, animate: animate, sticky: stickyFooter }">
			<slot name="footer"></slot>
		</div>
		<div v-if="$slots.links" class="page-links">
			<slot name="links"></slot>
		</div>
	</div>
</template>

<script>
import { onMounted, ref } from '@vue/runtime-core'

const SUPPORTED_THEMES = ['default', 'gray', 'passio']

export default {
	props: {
		animate: {
			type: Boolean,
			default: false
		},

		customStyles: {
			type: Object,
			default: () => ({})
		},

		theme: {
			type: String,
			validation: (value) => {
				return SUPPORTED_THEMES.includes(value)
			}
		},

		stickyFooter: {
			type: Boolean,
			default: true
		}
	},

	setup() {
		const showFooter = ref(false)

		onMounted(() => {
			setTimeout(() => {
				showFooter.value = true
			}, 500)
		})

		return {
			showFooter
		}
	}
}
</script>

<style lang="scss" scoped>
.page {
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	background-color: var(--page-background-color, #fff);

	&.dark-primary {
		color: #424982;
	}

	&-content {
		text-align: left;
		flex: 1 0 auto;
		// padding-bottom: 10px;

		@media (min-width: 768px) {
			flex: none;
		}
	}

	&-footer {
		z-index: 1;
		padding: 25px 0;
		text-align: center;

		background: rgb(255, 255, 255);
		background: linear-gradient(
			0deg,
			rgba(255, 255, 255, 1) 0%,
			rgba(255, 255, 255, 1) 74%,
			rgba(255, 255, 255, 0) 100%
		);

		&.sticky {
			position: sticky;
			bottom: 0;
		}

		&.animate {
			@media (max-width: 991px) {
				transform: translateY(100%);
				// opacity: 0;
				transition: transform 0.3s;

				&.show {
					// opacity: 1;
					transform: translateY(0%);
				}
			}
		}
	}

	&-links {
		padding-bottom: 20px;
		margin-top: -20px;
	}

	&.passio {
		background-image: url('~@/assets/paywall/passio-bg.png');
	}

	&.gray {
		background-color: #f0f0f3;
	}
	&.gray & {
		&-footer {
			background: linear-gradient(
				0deg,
				rgba(240, 240, 243, 1) 0%,
				rgba(240, 240, 243, 1) 74%,
				rgba(240, 240, 243, 0) 100%
			);
		}
	}

	&.transparent {
		background-color: transparent;
	}

	&.transparent & {
		&-footer {
			background: transparent;
		}
	}
}
</style>
